import { render, staticRenderFns } from "./MerchantManagement.vue?vue&type=template&id=3b527c34&scoped=true"
import script from "./MerchantManagement.vue?vue&type=script&lang=js"
export * from "./MerchantManagement.vue?vue&type=script&lang=js"
import style0 from "./MerchantManagement.vue?vue&type=style&index=0&id=3b527c34&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b527c34",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b527c34')) {
      api.createRecord('3b527c34', component.options)
    } else {
      api.reload('3b527c34', component.options)
    }
    module.hot.accept("./MerchantManagement.vue?vue&type=template&id=3b527c34&scoped=true", function () {
      api.rerender('3b527c34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/collectionCenter/BasicData/MerchantManagement.vue"
export default component.exports